import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiInfo } from 'react-icons/fi';
import { AiOutlineTrophy } from 'react-icons/ai';
import { t } from 'i18next';
import { IconVerified } from '@/components/custom/icon';
import { Button } from '@/components/ui/button';
import { Badge, BadgeGroup } from '@/components/ui/badge';
import { ModuleCard, ModuleCardAlert, ModuleCardHeader, ModuleCardHeaderContent, ModuleCardText, ModuleCardTitle } from '@/components/custom/module';
import { MedalContainer } from '@/components/custom/medal';

export function CourseMonitoringModuleCard(props) {
  const navigate = useNavigate();
  const { module, courseId, canAccess } = props;

  const getModuleStatus = module => {
    const now = new Date();
    let badgeVariant = '';
    let badgeText = '';
    let disclaimer = false;

    if (module?.learning_system_users?.length === 0) {
      badgeVariant = 'warning';
      badgeText = 'Novo';
    }
    if (module?.progress === 100 && now >= new Date(module?.finished_at)) {
      badgeVariant = 'success';
      badgeText = 'Concluído';
    }
    if (module?.progress === 100 && now < new Date(module?.finished_at)) {
      badgeVariant = 'warning';
      badgeText = 'Em andamento';
      disclaimer = true;
    }
    if (module?.progress < 100 && module?.progress > 0) {
      badgeVariant = 'warning';
      badgeText = 'Em andamento';
    }

    return { badgeVariant, badgeText, disclaimer };
  };

  const { badgeVariant, badgeText, disclaimer } = getModuleStatus(module);

  return (
    <ModuleCard onClick={() => navigate(`/curso/${courseId}/modulo/${module.id}/sobre`)}>
      <ModuleCardHeader className="w-[350px]">
        <ModuleCardHeaderContent>
          <div className="flex items-start gap-1">
            {module?.['official_content'] && <IconVerified />}
            <ModuleCardTitle title={module?.title}>{module?.title}</ModuleCardTitle>
          </div>
        </ModuleCardHeaderContent>
      </ModuleCardHeader>

      {disclaimer ? (
        <ModuleCardAlert>
          <FiInfo
            data-tooltip-content={`O certificado do módulo estará disponível a partir de ${new Date(module?.finished_at).toLocaleDateString('pt-br')}`}
            size={16}
          />
          <span>
            Parabéns, todas as aulas foram concluídas. <b>Mantenha-se atento, mais conteudos podem chegar em breve.</b>
          </span>
        </ModuleCardAlert>
      ) : (
        <BadgeGroup>
          {badgeText && (
            <Badge
              variant={badgeVariant}
              size="xs"
              className="cursor-pointer"
            >
              {badgeText}
            </Badge>
          )}
        </BadgeGroup>
      )}

      <ModuleCardText>
        {module?.progress === 0 ? <strong>0</strong> : <strong>{module?.learning_system_items_finished_count}</strong>}/{module?.learning_system_items_total_count} {t('lms.lms')}
      </ModuleCardText>

      {module?.progress === 100 && (
        <MedalContainer
          size="sm"
          src="more"
          value={<AiOutlineTrophy />}
        />
      )}

      <Button
        variant="outline"
        wide
        disabled={!canAccess}
        className="hidden sm:flex"
      >
        Acessar
      </Button>

      {/* <ModuleCardFooter>
        {newModule ? (
          <Button
            variant="outline"
            wide
            fullWidth
            className="hidden sm:flex"
          >
            Visualizar
          </Button>
        ) : (
          <>
            <ModuleCardText>{t('lms.buttonContinue')}</ModuleCardText>
            <ModuleCardLink to={`/show-course/${374}/classroom`}>
              <CardIcon>
                <FiPlayCircle size={16} />
              </CardIcon>
              <ModuleCardLinkText title={'Aula 2 - Física clássica'}>Aula 2 - Física clássica</ModuleCardLinkText>
            </ModuleCardLink>
          </>
        )}
      </ModuleCardFooter> */}
    </ModuleCard>
  );
}
